export const PADDINGS = 60;
export const SCROLL_GAP = 50;
export const SCROLL_STEP = 600;
export const SCROLLER_OFFSET = 10;
export const SCROLL_THRESHOLD = 100;
export const DEFAULT_ID = 'default';
